<script lang="ts">
  // Signature element: a small panel-mount indicator lamp — Toyama builds
  // industrial control panels, so real-time presence/status here reads as a
  // bevelled, glowing pilot light rather than a generic colored dot or
  // avatar badge. Used deliberately in one place (Overview + Sites
  // occupancy); every other status signal on these pages stays a plain
  // quiet badge.
  const {
    tone,
    pulse = false,
    label
  }: {
    tone: 'good' | 'warn' | 'bad' | 'idle';
    pulse?: boolean;
    label?: string;
  } = $props();
</script>

<span
  class="tym-lamp tym-lamp--{tone} {pulse ? 'tym-lamp--pulse' : ''}"
  role={label ? 'img' : undefined}
  aria-label={label}
></span>
